import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { styled, useTheme } from "@mui/material/styles";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Stack,
  TextField,
} from "@mui/material";
import { useState } from "react";

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& input": {
    padding: "10px 14px",
  },
}));

const FinancialYearFilter = (props) => {
  const {handleSearchYear, handleSearchPeriod, handleMainRowDialogOpen, handleClearYear, handleSearch} = props
  const [year, setYear] = useState('')
  const [period, setPeriod] = useState('')

  return (
    <>
    <Box className="p-24" sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <div className="flex">
              <FormControl className="flex flex-row">
                {/* <div className="mr-16">
                  <label>Company</label>
                  <StyledTextField type="text" variant="outlined" name="company" fullWidth />
                </div> */}
                <div className="mr-16">
                  <label>Financial Year</label>
                  <StyledTextField type="text" variant="outlined" fullWidth name="year" value={year} 
                  onChange={(e) => {setYear(e.target.value); handleSearch(e.target.value)}}  />
                </div>
                <div className="mr-16">
                  <label>Period</label>
                  <StyledTextField type="text" variant="outlined" fullWidth name="period" value={period} 
                  onChange={(e) => {setPeriod(e.target.value); handleSearchPeriod(e.target.value)}} />
                </div>
                {/* <div className="mt-16 flex">
                  <Button
                    color="warning"
                    variant="contained"
                    startIcon={
                      <FuseSvgIcon size={18}>
                        heroicons-outline:search
                      </FuseSvgIcon>
                    }
                    sx={{ mr: 1 }}
                    onClick={() => handleSearchYear(year) || handleSearchPeriod(period)}
                  >
                    Search
                  </Button>
                  <Button
                    color="warning"
                    variant="contained"
                    onClick={() => {handleClearYear(); setYear('')}}
                  >
                    Clear
                  </Button>
                </div> */}
              </FormControl>
            </div>
          </Grid>
          {/* <Grid item xs={6} className="flex justify-end">
              <Button
                    color="warning"
                    variant="contained"
                    startIcon={
                      <FuseSvgIcon size={18}>
                        heroicons-outline:plus
                      </FuseSvgIcon>
                    }
                    onClick={handleMainRowDialogOpen}
                  >
                    Add
                  </Button>
          </Grid> */}
        </Grid>
      </Box>
    </>
  )
}

export default FinancialYearFilter;
